export default __webpack_public_path__ + "static/media/Newspaper Publication of Postal Ballot Notice.c3a13d76.pdf";